import React from "react";
import { updateElPublications } from '../../api/electronic-publications/actions'
import { updateCustomer } from '../../api/customers/actions'
import { formatKennitala, validateEmail, validatePhoneNumber } from "../../utils";
import { SvgPenIcon, SvgCheckIcon } from '../svg'


class DetailedCustomerInfo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            editing: {
                phone: false,
                cellularPhone: false,
                email: false
            },
            errors: {
                phone: '',
                cellularPhone: '',
                email: '',
            }
        }
        this.toggleEditField = this.toggleEditField.bind(this)
        this.updateElectronicPublications = this.updateElectronicPublications.bind(this)
        this.onChangeTextInput = this.onChangeTextInput.bind(this)
        this.saveData = this.saveData.bind(this)
        this.validateForm = this.validateForm.bind(this)

        this.phone = React.createRef()
        this.cellularPhone = React.createRef()
        this.email = React.createRef()
    }

    validateForm(key) {
        let errors = this.state.errors
        let validateFunction = {}
        let errorString = ""
        if (key === 'phone' || key === 'cellularPhone'){
            validateFunction = validatePhoneNumber
            errorString = 'Símanúmer er ekki gilt'
        } else {
            validateFunction = validateEmail
            errorString = 'Netfang er ekki gilt'
        }

        let valid = validateFunction(this[key].current.value)
        errors[key] = valid ? '' : errorString

        this.setState({ errors: errors })
        return valid;
    }

    componentDidMount() {
        let customer = this.props.customers.customerList[0].Customer
        this.setState({
            email: customer.Email,
            phone: customer.Phone,
            cellularPhone: customer.CellularPhone,
        })
    }

    toggleEditField(fieldName) {
        let state = {...this.state}
        state.editing[fieldName] = !state.editing[fieldName]
        this.setState(state)
    }

    updateElectronicPublications(customer, e) {
        this.props.dispatch(updateElPublications(customer.AccountNum, e.currentTarget.checked))
    }

    onChangeTextInput(event) {
        this.setState({ [event.target.name]: event.target.value })
    }
    
    saveData(key) {
        if (this.validateForm(key)) {
            let customerId = this.props.customers.customerList[0].Customer.AccountNum
            Promise.resolve(this.props.dispatch(updateCustomer(customerId, { 
                phone: this.state.phone, 
                cellular_phone: this.state.cellularPhone, 
                email: this.state.email 
            }))).then(() => {
                let state = {...this.state}
                state.editing[key] = !state.editing[key]
                this.setState(state)
            })
        }
    }

    render() {
        let customers = this.props.customers;
        let customer = customers.customerList[0].Customer

        return (
            <div className="edit-customer">
                <div className="form-row">
                    <div className="col-sm-4"><label htmlFor="" className="">Tryggingataki</label></div>
                    <div className="col-sm-8 text-left">
                        { customer.Name }
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-sm-4"><label htmlFor="" className="">Kennitala</label></div>
                    <div className="col-sm-8 text-left">
                        { formatKennitala(customer.AccountNum) }
                    </div>
                </div>
                <div className={`${this.state.errors.phone.length > 0 ? 'error' : ''} form-row`}>
                    <div className="col-sm-4">
                        <label htmlFor="" className="">
                            Sími
                            {this.state.errors.phone.length > 0 ?
                                <span className="error"> ({this.state.errors.phone}) </span> : ''
                            }
                        </label>
                    </div>
                    <div className="col-sm-8 text-left">
                        { this.state.editing.phone ?
                            <>
                                <input ref={this.phone} id="phone" type="tel" pattern="[0-9]" className="form-control text-right" name="phone" onChange={this.onChangeTextInput} placeholder="Sláðu inn símanúmer" value={this.state.phone} />
                                <button onClick={() => this.saveData('phone')} className="btn btn-primary edit"><SvgCheckIcon /></button>
                            </>
                        :
                            <a onClick={() => this.toggleEditField('phone')}>{ (this.state.phone === undefined || this.state.phone === '') ? 'Ekkert símanúmer skráð' : this.state.phone } <SvgPenIcon /></a>
                        }
                    </div>
                </div>
                <div className={`${this.state.errors.cellularPhone.length > 0 ? 'error' : ''} form-row`}>
                    <div className="col-sm-4">
                        <label htmlFor="" className="">
                            Farsími
                            {this.state.errors.cellularPhone.length > 0 ?
                                <span className="error"> ({this.state.errors.cellularPhone}) </span> : ''
                            }
                        </label>
                    </div>
                    <div className="col-sm-8 text-left">
                        { this.state.editing.cellularPhone ?
                            <>
                                <input ref={this.cellularPhone} id="cellularPhone" type="tel" pattern="[0-9]" className="form-control text-right" name="cellularPhone" onChange={this.onChangeTextInput} placeholder="Sláðu inn símanúmer" value={this.state.cellularPhone} />
                                <button onClick={() => this.saveData('cellularPhone')} className="btn btn-primary edit"><SvgCheckIcon /></button>
                            </>
                        :
                            <a onClick={() => this.toggleEditField('cellularPhone')}>{ (this.state.cellularPhone === undefined || this.state.cellularPhone === '') ? 'Ekkert farsímanúmer skráð' : this.state.cellularPhone } <SvgPenIcon /></a>
                        }
                    </div>
                </div>
                <div className={`${this.state.errors.email.length > 0 ? 'error' : ''} form-row`}>
                    <div className="col-sm-4">
                        <label htmlFor="" className="">
                            Netfang
                            {this.state.errors.email.length > 0 ?
                                <span className="error"> ({this.state.errors.email}) </span> : ''
                            }
                        </label>
                    </div>
                    <div className="col-sm-8 text-left">
                        { this.state.editing.email ?
                            <>
                                <input ref={this.email} id="email" type="email" className="form-control text-right" name="email" onChange={this.onChangeTextInput} placeholder="Sláðu inn netfang" value={this.state.email} />
                                <button onClick={() => this.saveData('email')} className="btn btn-primary edit"><SvgCheckIcon /></button>
                            </>
                        :
                            <a onClick={() => this.toggleEditField('email')}>{ (this.state.email === undefined || this.state.email === '') ? 'Ekkert netfang skráð' : this.state.email } <SvgPenIcon /></a>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-sm-4 col-6 col-form-label"><label htmlFor="el-pub" className="col-form-label">Afþakka pappír</label></div>
                    <div className="col-sm-8 col-6 text-left checkbox">
                        <input type="checkbox" id="el-pub" name="el-pub" defaultChecked={customer.ElectronicPublication === "0" ? false : true} onChange={(e) => this.updateElectronicPublications(customer, e)} />
                        <label htmlFor="el-pub" className="col-sm-10 col-form-label"></label>
                    </div>
                </div>
            </div>
        )
    }
}

export default DetailedCustomerInfo